import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './overview.reducer';
import { PortfolioValuationData, InvestmentGrowthData, HoldingsData } from './overview.models';

export const selectOverviewState = createFeatureSelector<State>('overview');

export const selectOverviewLoading = createSelector(selectOverviewState, (state: State) => state.loading);

export const selectPortfolioValuation = createSelector(selectOverviewState, (state: State) =>
  state && state.data ? state.data['portfolio-valuation'] : undefined
);

export const selectPortfolioValuationValue = createSelector(selectPortfolioValuation, (state?: PortfolioValuationData) =>
  state ? (Math.round(state.amount * (Math.pow(10, 0))) / (Math.pow(10, 0))).toFixed(0) : undefined
);

export const selectPortfolioValuationDate = createSelector(selectPortfolioValuation, (state?: PortfolioValuationData) =>
  state ? state.date : undefined
);

export const selectInvestmentGrowth = createSelector(selectOverviewState, (state: State) =>
  state && state.data ? state.data['investment-growth'] : undefined
);

export const selectInvestmentGrowthDate = createSelector(selectInvestmentGrowth, (state?: InvestmentGrowthData) =>
  state ? state.date : undefined
);

export const selectInvestmentGrowthData = createSelector(selectInvestmentGrowth, (state?: InvestmentGrowthData) =>
  state ? state.data : undefined
);

export const selectAssetAllocation = createSelector(selectOverviewState, (state: State) =>
  state && state.data && state.data.holdings ? state.data.holdings : undefined
);

export const selectAssetAllocationDate = createSelector(selectAssetAllocation, (state?: HoldingsData) =>
  state ? state.date : undefined
);

export const selectAssetAllocationData = createSelector(selectAssetAllocation, (state?: HoldingsData) =>
  state && state.data ? state.data : undefined
);

export const selectPerformanceValuation = createSelector(selectOverviewState, (state: State) =>
  state && state.data ? state.data['performance'] : undefined
);

export const selectPerformanceValuationDate = createSelector(selectPerformanceValuation, (state: any) =>
  state ? state.date : undefined
);

export const selectPerformanceValuationHoldingDate = createSelector(selectPerformanceValuation, (state: any) =>
  state ? state.holdingDate : undefined
);

export const selectPerformanceValuationData = createSelector(selectPerformanceValuation, (state: any) =>
  state ? state.data : undefined
);

export const selectPerformanceValuationAvailability = createSelector(selectPerformanceValuationData, (state: any) =>
  /**
   * Custom check for displaying or hiding Performance Valuations table on Overview page
   * Assume that total values are irrelevant, check if Funds is set and has length greater than 0
   */
  state && state.hasOwnProperty('funds') ? !!state.funds.length : undefined
);

export const selectPerformanceValuationFunds = createSelector(selectPerformanceValuationData, (state: any) =>
  state ? state.funds : []
);

export const selectMicData = createSelector(selectOverviewState, (state: State) =>
  state && state.data && state.data['mercer-insight-community'] ? state.data['mercer-insight-community'] : undefined
);
